<div class="row">
    <div class="col-24">
        <div class="bold-font bottom-20">
            Thank You!
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div class="bold-font bottom-20">Online Enrollment Confirmation # {{confirmationNumber}}</div>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <br />
        <p>
            I would like to offer you a confirmation number. This number will be used to confirm your enrollment. (Agent Provides Confirmation Number generated from the system)
        </p>

        <p>
            <br />
            Thank you and have a great day! Goodbye!
        </p>

    </div>
</div>
<div class="row">
    <div class="col-24">
        <a class="link-button link print" routerLink="/enrollment/print" target="_blank" >Print a hard copy of the enrollment Form</a>
        <!--<button class="button primary" (click)="printHardCopy()">Print a hard copy of the enrollment Form >></button>-->
    </div>
</div>
<div class="row">
    <div class="col-24">
        <a href="javascript:void(0)" class="link-button link pdf" (click)="SavePdf()">Save PDF of Completed Enrollment Data</a>
        <!--<button class="button secondary" (click)="SavePdf()">Save PDF of Completed Enrollment Data</button>-->
    </div>
</div>
<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="enrollNew()">Enroll another client</button>
    </div>
</div>







